export default {
	tm:'此記',
	qjt:'秋俊天',
	amap:'高德地圖',
	copyright:'©@year 此記·秋俊天',
	username:'賬號',
	nickname:'昵稱',
	password:'密碼',
	email:'郵箱',
	wechat:'微信',
	registertime:'註冊時間',
	verifyCode:'驗證碼',
	terms:"服務條款",
	contactUs:"聯系我們",
	contactUsText:"請發送郵件至",
	user:"此記用戶",
	space:"",
	loading:"讀取中...",
	hello:{
		morning:'「@nickname」上午好',
		afternoon:'「@nickname」下午好',
		evening:'「@nickname」晚上好',
		midnight:'「@nickname」淩晨了',
		slogan1:'此生此夜不長好，惟願此記憶平生',
		slogan2:'此記亦悠悠',
		slogan3:'我是人間惆悵客，知君何事淚縱橫',
		slogan4:'隨君萬裡，相期始終',
		slogan5:'三步兩步，便是天堂',
		slogan6:'山河雖遠亦復見',
	},
	sloganNum:'6',
	footprint:{
		fp:'足跡',
		longitude:'經度',
		latitude:'緯度',
		scale:'縮放等級',
		address:'地址',
		addressEmpty:'暫無地址',
		note:'備註',
		noteInputTip:'備註字數：',
		noteEmpty:'暫無備註',
		time:'時間',
		timeFormat:'YYYY年MM月DD日 HH:mm:ss',
		icon:'圖標',
		empty:'暫無足跡',
	},
	icon:{
		all:'全部',
		cluster:'足跡盒子',

		default:'此記默認',
		note:'筆記',

		family:'家庭',
		love:'伴侶',
		friend:'朋友',
		pet:'寵物',
		workf:'工作（女）',
		workm:'工作（男）',
		student:'學生',

		food:'美食',
		travel:'旅行',
		photo:'攝影',
		shopping:'購物',
		amusement:'娛樂',
		sport:'運動',

		special:'特殊',
		positive:'正能量',
		negative:'負能量',

		jnq:'將年輕',
	},
	btn:{
		close:'關閉',
		return:'返回',
		returnLast:'返回上頁',
		returnIndex:'返回首頁',
		top:'回到頂部',
		login:'登錄',
		bind:'綁定',
		unbind:'解綁',
		logout:'註銷登錄',
		signup:'加入此記',
		forget:'忘記密碼',
		record:'記錄',
		edit:'編輯',
		delete:'刪除',
		modify:'修改',  
		share:'分享',
		shareEnd:'退出',
		reset:'重置',
		sendLink:'發送驗證鏈接',
		change:'更改',
		send:'發送',
		second:'秒',
		relocate:'重新定位',
		mapFull:'地圖全屏',
		mapWindow:'地圖縮小',
	},
	form:{
		usernameSub:"用於登錄，6-15位/只限於英文大小寫、數字",
		passwordSub:"用於登錄，6-15位/只限於英文大小寫、數字",
		repasswordSub:"重復輸入一次",
		nicknameSub:"用於顯示，1-10位/可以為中（繁簡）英文、數字、-_",
		emailSub:"用於接收賬戶安全信息及重置密碼",
		verifyCodeSub:"8位證碼",
		shareTitleSub:"分享標題（可為空），1-10位/可以為中（繁簡）英文、數字、-_",

		nullError:"該項不能為空",
		lengthError:"字符數應介於@min與@max之間",
		lengthOnlyError:"字符數應為@length位",
		n0Error:"只限於數字",
		Aa0Error:"只限於英文大小寫、數字",
		Aa0ZhZhtUDError:"只限於中（繁簡）英文、數字、-_",
		emailError:"郵箱格式不符合規範",
		sameError:"與@feild不相同，請重新輸入",
		repeatError:"@feild已經被占用，請修改",
	},
	_login:{
		title:'登錄',
	},
	_signup:{
		title:'加入此記',
	},
	_forget:{
		title:'忘記密碼',
	},
	_index:{
		title:'首頁',
	},
	_record:{
		title:'記錄足跡',
		info:'足跡信息',
		selectIcon:'選擇圖標',
		inputNote:'填寫備註（可為空）',
	},
	_review:{
		title:'回顧足跡',

		review:'回顧',
		map:'地圖',

		mapsettings:'地圖設置',

		mapcluster:'足跡聚合',
		mapclustertips:'足跡過多時，關閉聚合可能導致性能降低',

		mapstyle:'地圖樣式',
		mapdefault:'高德默認',
		maproad:'高德路網',
		mapsat:'高德衛星',
		mapsatroad:'高德衛星路網',
		mapgoogle:'谷歌默認',
		mapgooglegeo:'谷歌地理',
		mapgooglesat:'谷歌衛星',
		mapstamentoner:'Stamen黑白',
		mapstamenwatercolor:'Stamen水彩',

		detail:'詳情',
		modifyIcon:'修改圖標',
		modifyNote:'修改備註',
		openedBy:'在導航程式打開',

		search:'足跡搜索',
		searchPlaceHolder:'輸入相關信息，空格分割關鍵詞',
		searched:'當前搜索到@count個足跡',

		shareTip:'點擊足跡進行選擇\n選擇完成後點擊“足跡分享”',
		shareSelected:'已選擇',
		shareSelectedRepeat:'該足跡已經被選中',
	},
	_achievement:{
		title:'我的成就',

		all:'全部',
		fp:'足跡',
		china:'中國',
		world:'世界',
		special:'特殊',
		achi:'成就',

		empty:'暫無足跡成就',

		getAchi:'獲得新成就',
		getSpecial:'完成於',
		notGetSpecial:'暫未全部完成',

		mostRecord:'最常記錄',
		mostActive:'最常活動於',
	},
	share:{
		footprint:'足迹分享',
		achievement:'成就分享',
		sharedBy:'分享自',
		shareS:'的',
		join:'掃描二維碼關註微信公眾號\n或點擊',
	},
	_shareFoorprints:{
		title:'足跡分享',
	},
	_shareAchievement:{
		title:'成就分享',

		overview:'成就总览',
		overview1:'自從「@time」以來，我已記錄足跡',
		overviewPrefix:'共',
		overviewUnit:'個',
	},
	_settings:{
		title:'我的設置',
		settings:'設置項',
		shared:'分享列表',
		unrecorded:'待記足跡',

		info:'賬號信息',
		language:'Language',
		resetPassword:'重置密碼',
		changeMail:'更改郵箱',
		unbindWechat:'解綁微信',
		unbindEmpty:'暫未綁定微信',

		submit:'提交列表',
		share:'分享列表',
		option:'操作',
		listEmpty:'列表暫無內容',
		sharedFp:'足跡',
		pageView:'瀏覽',
	},
	_resetPassword:{
		title:'重置密碼',
		newPassword:'新密碼',
	},
	_changeMail:{
		title:'更改郵箱',
		newMail:'新郵箱',
	},
	_wechatBind:{
		title:'綁定微信',
		tips:'在此登錄您的此記賬號即可完成綁定',
	},
	_about:{
		title:'關於與幫助',
		slogan:'現在好了，\n你已擁有一個嶄新的此記。',
		wechat:'將賬號綁定到此記公眾平臺後，可以利用微信進入',

		recordSlogan:'此時此地，在空間中創建屬於自己的唯一坐標',
		recordHelp1:'首頁點擊如下圖標，進入此功能。',
		recordHelp2:'此功能需要開啟GPS的定位功能，並且同意此記使用定位功能（部分桌面端瀏覽器可能無法定位）。',
		recordHelp3:'如果彈出是否允許使用位置的對話框，請選擇允許；否則程序將不能定位。當地圖上顯示足跡圖標，說明定位成功。',
		recordHelp4:'在地圖右下角可能會有兩個按鈕，功能如下：',
		recordHelp41:'微信記錄不會出現',
		recordHelp5:'選擇足跡圖標、填寫足跡備註（備註可以為空）。',
		recordHelp61:'點擊頁面底部',
		recordHelp62:'，保存當前足跡。',
		
		reviewSlogan:'回顧走過的路，與他人分享',
		reviewHelp1:'首頁點擊如下圖標，進入此功能。',
		reviewHelp2:'查看足跡：點擊任何一個地圖上的足跡圖標，進入足跡詳情。',
		reviewHelp3:'修改足跡：足跡詳情 → 編輯 → 修改內容 → 修改足跡。',
		reviewHelp4:'刪除足跡：足跡詳情 → 編輯 → 刪除。',
		reviewHelp5:'搜索足跡：點擊如下圖標進入，輸入相關信息進行搜索，可以用空格分割關鍵詞（點擊足跡圖標可以添加圖標分類搜索條件）。',
		reviewHelp6:'地圖設置：點擊如下圖標進入，可以設置地圖相關顯示偏好。',
		reviewHelp7:'足跡分享：點擊如下圖標進入。',

		achiSlogan:'「為了世界和平，我要練到滿級！」',
		achiHelp1:'首頁點擊如下圖標，進入此功能。系統會自動顯示您已經開啟的足跡成就。',
		achiHelp2:'足跡成就：點擊如下圖標進入。',

		settingSlogan:'帶著背包和個性，走遍世界',
		settingHelp1:'首頁點擊如下圖標，進入此功能。',
		settingHelp2:'設置項：可以設置語言、重置密碼等操作。',
		settingHelp3:'已分享：管理自己已分享的足跡、成就頁面。',
		settingHelp31:'查看已分享頁面',
		settingHelp4:'未提交：管理自己已提交還未記錄的足跡。',
		settingHelp41:'點擊記錄該足跡',

		wechatHelp1:'此記不會以任何理由索要您的微信賬號和密碼，謹防上當受騙。',
		wechatHelp2:'綁定微信的好處',
		wechatHelp211:'定位功能',
		wechatHelp212:'定位更準確\n定位更快速',
		wechatHelp221:'安全性',
		wechatHelp222:'無須驗證密碼\n靈活安全',
		wechatHelp231:'彈性記錄',
		wechatHelp232:'一次提交多個足跡\n逐一填寫備註',
		wechatHelp3:'如何綁定',
		wechatHelp31:'首先，妳必須擁有一個此記的賬戶，如果沒有，請註冊。',
		wechatHelp32:'關註此記微信公眾平臺：搜索微信號「thismemo」或掃描下方二維碼。',
		wechatHelp33:'進入公眾號，點擊頁面正下方「綁定微信」。',
		wechatHelp34:'在頁面中，輸入此記賬號和密碼，提示成功後，即可使用微信來登錄、操作此記了。',
		wechatHelp4:'如何解綁',
		wechatHelp41:'任意方式登錄此記，首頁 → 我的設置 → 設置項 → 解除綁定。',

		others:'其他',
		acknowledgement:'感謝「林老北」、「哲仔」、「林大雨」、「餃子」',
	},
	_404:{
		title:'404',
		tip:'該頁面已經不復存在\n大家都在尋找它',
	},
	_notice:{
		title:'提示',
		AUTH_FAILED:'鏈接已失效，請在微信公眾號中再次發送',
		BIND_WECHAT_SUCCESS:'綁定成功！關閉此頁面即可使用微信版此記功能',
		ALREADY_BIND_WECHAT:'該微信已經綁定了此記賬號，無需再次綁定。如需更換此記賬號，請解綁後再試',
	},
	BACKENDMSG:{
		undefined:'未知錯誤，請稍後再試',
		UNKNOWN_ERROR:'未知錯誤，請稍後再試',
		WRONG_SESSION:'登錄過期，請重新登錄',
		WRONG_TOKEN:'登錄失效，請重新登錄',
		DIFFERENT_TOKEN:'登錄失效，請重新登錄',
		LOGIN_SUCCESS:'登錄成功',
		LOGIN_WRONG_USERNAME:'賬號錯誤',
		LOGIN_WRONG_PASSWORD:'密碼錯誤',
		LOGOUT_SUCCESS:'註銷登錄成功',
		RFP_M_Q:'確認修改足跡？',
		RFP_M_END_Q:'足跡已經更改，確認放棄修改？',
		RFP_M_FAIL:'足跡修改失敗，請稍後再試',
		RFP_M_SAME:'足跡沒有修改，不能提交',
		RFP_M_SUCCESS:'足跡修改成功',
		RFP_D_Q:'足跡刪除不可恢復，確認刪除麽？',
		RFP_D_FAIL:'足跡刪除失敗，請稍後再試',
		RFP_D_SUCCESS:'足跡刪除成功',
		RFP_SH_FAIL:'沒有選擇足跡，不能分享',
		RFP_SH_SUCCESS:'分享頁面生成中，請等待頁面跳轉',
		RECFP_LOCATE_ERROR:'獲取位置失敗，請檢查網絡、GPS設置、允許獲取地理位置。\n確認後請點擊重新定位按鈕。',
		RECFP_LOCATE_NOT_HTTPS:'獲取位置失敗，請聯系管理員。',
		RECFP_LOCATE_PERMISSION_DENIED:'獲取位置失敗，請允許獲取位置的權限。',
		RECFP_LOCATE_POSITION_UNAVAILABLE:'獲取位置失敗，當前位置信息不可用。',
		RECFP_LOCATE_TIMEOUT:'獲取位置失敗，獲取位置信息超時。',
		RECFP_LOCATE_UNKNOWN_ERROR:'獲取位置失敗，未知錯誤。',
		RECFP_RELOCATE:'正在重新定位，請稍後再試',
		RECFP_REC_FAIL:'記錄足跡失敗，請稍後再試',
		RECFP_REC_SUCCESS:'記錄足跡成功',
		ACHI_FAIL:'讀取成就失敗，請稍後再試',
		ACHI_SUCCESS:'讀取成就成功',
		U_SETLANG_SUCCESS:'保存常用語言成功',
		U_SETLANG_FAIL:'保存常用語言失敗，請稍後再試',
		U_UNBIND_WECHAT_Q:'確認解綁微信？',
		U_LIST_D_Q:'刪除後不可恢復，確認刪除？',
		SIGNUP_SEND_WRONG_EMAIL:'請輸入正確的郵箱地址',
		SIGNUP_SEND_1MIN:'請在@sec秒後再次嘗試發送',
		SIGNUP_SUCCESS:'註冊成功',
		SEND_EMAIL_SUCCESS:'相關信息成功發送至@email\n請檢查收件箱及垃圾郵件',
		SEND_EMAIL_FAIL:'發送郵件失敗，請稍後再試',
		SEND_EMAIL_EMPTY:'您的賬號還未綁定郵箱\n請點擊頁面底部聯系我們，聯系管理員綁定郵箱',
		FORM_WRONG:'輸入信息不合符規範，請檢查',
		FORM_VC_SEND_SUCCESS:'驗證碼成功發送至@email\n請檢查收件箱及垃圾郵件',
		FORM_VC_WRONG:'驗證碼錯誤，請檢查',
		FORM_VC_EXPIRED:'驗證碼已過期，請重新發送',
		RESET_EXPIRED:'鏈接已過期，請重新發送',
		RESET_UNFOUND:'鏈接已不存在，請重新發送',
		RESET_SUCCESS:'更改成功',
		RESET_P_SAME:'新舊密碼相同，請輸入不同的密碼',
		RESET_MAIL_SAME:'新舊郵箱相同，請輸入不同的郵箱',
		RESET_LOGIN_FORGET_UNFOUND_USERNAME:'沒有找到登錄賬戶，請重新輸入',
		RESET_LOGIN_FORGET_EMAIL_UNSAME:'您輸入的郵箱地址與註冊時的不同，請重新輸入',
		UNBIND_SUCCESS:'解除綁定成功',
		NOT_BIND_WECHAT:'暫未綁定微信',
		BIND_WECHAT_UNFOUND:'鏈接已失效，請在微信公眾號中再次發送',
		TAKEN_BIND_WECHAT:'您的微信已經綁定了其他賬號，請解綁後再試',
		ALREADY_BIND_WECHAT:'您的賬號已經綁定了其他微信，請解綁後再試',
		BIND_SUCCESS:'成功綁定微信，您已可以在公眾號中使用所有功能',
		REDIRECT_UNFOUND:'鏈接已失效',
	}
}



// WEBPACK FOOTER //
// ./src/lang/zht.js